export default __webpack_public_path__ + "static/media/mb8.0fb604d5.JPG";